import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Collapse } from "react-collapse";
import Slider from "react-slick";
import Image from "basic-elements/Image";
import PageLink from "basic-elements/PageLink";
import Hgroup from "public-components/Hgroup";
import Container from "public-components/Container";
import { Store } from "public-components/StoreProvider";
import "slick-carousel/slick/slick.css";
import styles from "./ScenarioSection.module.scss";

const sliderConfig = {
  arrows: false,
  slidesToShow: 1,
  dots: true
};

const DesktopScenarioSection = ({ data }) => {
  const [currentScenario, setCurrentScenario] = React.useState(data.homeScenariosList[0].id);

  return (
    <section className={styles.scenarios}>
      <Container>
        <Hgroup className={styles.scenarios__hgroup} heading={data.headingH2} />
        <div
          className={classnames(
            styles.scenarios__row,
            data.imagePosition === "right" ? styles.reverse : null
          )}
        >
          <div className={styles.scenarios__images}>
            {data.homeScenariosList.map(i => (
              <div
                key={`image-${i.id}`}
                className={styles.scenario__imageWrap}
                style={{ display: i.id === currentScenario ? "block" : "none" }}
              >
                <Image
                  className={styles.scenario__image}
                  data={i.image[0]}
                  noPlaceholderClassName
                />
              </div>
            ))}
          </div>
          <div className={styles.scenarios__content}>
            {data.homeScenariosList.map(i => (
              <div key={`content-${i.id}`} className={styles.scenario}>
                <h3
                  className={classnames(
                    styles.scenario__heading,
                    i.id === currentScenario ? styles.active : null
                  )}
                  onClick={() => setCurrentScenario(i.id)}
                >
                  {i.heading}
                </h3>
                <Collapse isOpened={i.id === currentScenario}>
                  <div
                    className={styles.scenario__text}
                    dangerouslySetInnerHTML={{ __html: i.text }}
                  />
                </Collapse>
              </div>
            ))}
            <PageLink
              className={styles.scenario__pageLink}
              data={data.pageLink}
              trackingType="trackEvent"
              trackingConfig={{
                category: "homePage-appEnter",
                action: "appEnter_click",
                label: `mid|${data.appType}`,
                openInNewTab: true
              }}
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

const MobileScenarioSection = ({ data }) => (
  <section className={styles.scenarios}>
    <Container>
      <Hgroup className={styles.scenarios__hgroup} heading={data.headingH2} />
      <Slider {...sliderConfig}>
        {data.homeScenariosList.map(i => (
          <div className={styles.scenarioSlider} key={i.id}>
            <Image className={styles.scenarioSlider__image} data={i.image[0]} />
            <h3 className={styles.scenarioSlider__heading}>{i.heading}</h3>
            <div
              className={styles.scenarioSlider__text}
              dangerouslySetInnerHTML={{ __html: i.text }}
            />
          </div>
        ))}
      </Slider>
    </Container>
  </section>
);

const ScenarioSection = ({ data }) => {
  const { state } = React.useContext(Store);
  if (state.isLargeScreen === undefined || state.isLargeScreen) {
    return <DesktopScenarioSection data={data} />;
  }
  return <MobileScenarioSection data={data} />;
};

ScenarioSection.propTypes = {
  data: PropTypes.shape({
    headingH2: PropTypes.string.isRequired,
    homeScenariosList: PropTypes.arrayOf(PropTypes.object),
    imagePosition: PropTypes.oneOf(["left", "right"]),
    pageLink: PropTypes.arrayOf(PropTypes.object),
    appType: PropTypes.string
  }).isRequired
};

export default ScenarioSection;
